module.exports = __webpack_public_path__ + "img/bm1.82fb4142.png";